import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=bbc78ae2&scoped=true&"
import script from "./Setting.vue?vue&type=script&lang=ts&"
export * from "./Setting.vue?vue&type=script&lang=ts&"
import style0 from "./Setting.vue?vue&type=style&index=0&id=bbc78ae2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc78ae2",
  null
  
)

export default component.exports